import React from 'react';
import { render } from '@testing-library/react';
import { ProgressTracker } from './ProgressTracker';

describe('ProgressTracker', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<ProgressTracker
				currentIndex={1}
				data-auto-sel="automation-selector"
			>
				<ProgressTracker.Step
					key={1}
					label="Step 1"
					href="http://google.com"
				/>
				<ProgressTracker.Step
					key={2}
					label="Step 2"
					href="http://google.com"
				/>
				<ProgressTracker.Step
					key={3}
					label="Step 3"
					href="http://google.com"
				/>
				<ProgressTracker.Step key={4} label="Step 4" />
			</ProgressTracker>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
